"use client";

import { i18nKey } from "@/lib/react/i18n/types/locale";
import React from "react";

type ContestBulkActionBarProps = {
  bulkMode: boolean;
  selectedCount: number;
  allCheckedOnPage: boolean;
  onEnableBulkMode: () => void;
  onDisableBulkMode: () => void;
  onToggleSelectAllOnPage: () => void;
  onBulkPublish: () => void;
  onBulkUnpublish: () => void;
  onBulkDelete: () => void;

  onBulkLock?: () => void;
  onBulkUnlock?: () => void;
  canUseLockActions?: boolean;

  t: (key: i18nKey) => string;
};

const ContestBulkActionBar = ({
  bulkMode,
  selectedCount,
  allCheckedOnPage,
  onEnableBulkMode,
  onDisableBulkMode,
  onToggleSelectAllOnPage,
  onBulkPublish,
  onBulkUnpublish,
  onBulkDelete,
  onBulkLock,
  onBulkUnlock,
  canUseLockActions = false,
  t,
}: ContestBulkActionBarProps) => {
  return (
    <div className="mt-4 mb-2">
      {!bulkMode ? (
        <div className="flex items-center justify-between rounded-xl border border-white/15 bg-white/5 px-3 py-2">
          <div className="text-xs text-white/70">{t("Bulk mode")}</div>
          <button
            type="button"
            onClick={onEnableBulkMode}
            data-testid="bulk-enable-button"
            className="rounded-lg px-3 py-2 text-xs bg-white/10 hover:bg-white/15 border border-white/15 text-white/80"
          >
            {t("Enable")}
          </button>
        </div>
      ) : (
        <div className="rounded-xl border border-white/15 bg-white/5 p-3 space-y-3">
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="text-xs text-white/70 truncate">
                {t("Bulk mode")}: <span className="text-white/85">{selectedCount}</span> {t("selected")}
              </div>
              <div className="text-[10px] text-white/45 mt-1">
                {t("Select contests and run actions.")}
              </div>
            </div>

            <button
              type="button"
              onClick={onDisableBulkMode}
              data-testid="bulk-disable-button"
              className="shrink-0 rounded-lg px-3 py-2 text-xs bg-white/10 hover:bg-white/15 border border-white/15 text-white/80"
            >
              {t("Disable")}
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {/* TODO: 無限スクロール全件選択はサーバーサイドフィルター方式で実装予定のため一時的にコメントアウト */}
            {/* <button
              type="button"
              onClick={onToggleSelectAllOnPage}
              className="rounded-lg px-3 py-2 text-xs bg-white/10 hover:bg-white/15 border border-white/15 text-white/80"
            >
              {allCheckedOnPage ? t("Unselect all") : t("Select all")}
            </button> */}

            <button
              type="button"
              onClick={onBulkPublish}
              data-testid="bulk-action-publish"
              className="rounded-lg px-3 py-2 text-xs bg-white/10 hover:bg-white/15 border border-white/15 text-white/80"
            >
              {t("Publish")}
            </button>

            <button
              type="button"
              onClick={onBulkUnpublish}
              data-testid="bulk-action-unpublish"
              className="rounded-lg px-3 py-2 text-xs bg-white/10 hover:bg-white/15 border border-white/15 text-white/80"
            >
              {t("Unpublish")}
            </button>

            {canUseLockActions && (
              <>
                <button
                  type="button"
                  onClick={onBulkLock}
                  data-testid="bulk-action-lock"
                  className="rounded-lg px-3 py-2 text-xs bg-amber-500/20 hover:bg-amber-500/25 border border-amber-500/30 text-amber-100"
                >
                  {t("Lock")}
                </button>

                <button
                  type="button"
                  onClick={onBulkUnlock}
                  data-testid="bulk-action-unlock"
                  className="rounded-lg px-3 py-2 text-xs bg-sky-500/20 hover:bg-sky-500/25 border border-sky-500/30 text-sky-100"
                >
                  {t("Unlock")}
                </button>
              </>
            )}

            <button
              type="button"
              onClick={onBulkDelete}
              data-testid="bulk-action-delete"
              className="rounded-lg px-3 py-2 text-xs bg-red-500/20 hover:bg-red-500/25 border border-red-500/30 text-red-200"
            >
              {t("Delete")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContestBulkActionBar;